import {Component, OnInit, ViewChild} from '@angular/core';
import {
  AbstractFieldInputTypeHandlerComponent,
  FormValueReadableValue
} from '../../type-handler/abstract-field-input-type-handler.component';
import {UntypedFormBuilder, UntypedFormControl, Validators} from '@angular/forms';
import {FormValueModel} from '../../../../../../modules/form/form/value/api/entity/formValue.model';
import {DomSanitizer, SafeResourceUrl} from '@angular/platform-browser';
import {FileItem} from 'ng2-file-upload';
import {FileUploadComponent} from '../../../../file-upload/file-upload.component';
import {
  FormDefinitionFieldModel
} from '../../../../../../modules/form/definition/field/api/entity/formDefinitionField.model';

@Component({
  templateUrl: './embedded-image-field-input-type-handler.component.html',
})
export class EmbeddedImageFieldInputTypeHandlerComponent extends AbstractFieldInputTypeHandlerComponent<UntypedFormControl>
    implements OnInit {

  public static resolveReadableValues(value: any): Promise<FormValueReadableValue[]> {
    return Promise.resolve([FormValueReadableValue.ofImage(value as string)]);
  }

  @ViewChild('fileUpload') fileUploadComponent: FileUploadComponent;

  constructor(private formBuilder: UntypedFormBuilder, private sanitizer: DomSanitizer) {
    super();
  }

  buildJsonControl(formDefinitionField: FormDefinitionFieldModel): UntypedFormControl {
    return this.formBuilder.control(undefined, formDefinitionField.required ? Validators.required : []);
  }

  initiateForm(formValue: FormValueModel): void {
    this.jsonControl.setValue(formValue?.value);
  }

  synchronizeValue(): string {
    return this.jsonControl.value;
  }

  get imageSrc(): SafeResourceUrl {
    return this.sanitizer.bypassSecurityTrustResourceUrl('data:image/png;base64, '
        + this.jsonControl.value);
  }

  onFileAdded(fileItem: FileItem) {
    if (fileItem) {
      this.setMeasured(true);
      const fileReader = new FileReader();
      fileReader.onload = (event) => {
        const base64 = btoa(event.target.result.toString());
        this.jsonControl.setValue(base64);
      };
      fileReader.readAsBinaryString(fileItem._file);
      this.fileUploadComponent.reset();
    }
  }


}
